/* jshint undef: true, unused: true */
/* globals require, define */

  var UUID = require('./pure-uuid/uuid');
    function uuid() {
        return new UUID(4).toString();
    }

    module.exports = uuid;
